module.exports = __webpack_public_path__ + "static/REGULAMIN-1d8a09b01bb1f37acb54a9840c4a28ab.pdf";